import Link from 'next/link';

const PaasHeader = () => {
  return (
    <>
      {/* PAAS HEADER TOP */}
      <div className="navbar-container container flex align-content-center mb-lg-3">
        <Link href="/" legacyBehavior>
          <a className="navbar-brand">
            <img
              src={`${process.env.NEXT_PUBLIC_BASE_URL}/fachhochschule-nordwestschweiz-fhnw-logo.svg`}
              alt="FHNW - Fachhochschule Nordwestschweiz"
              height={40}
              width={173.594}
            />
          </a>
        </Link>

        <button
          className="navbar-toggler position-absolute end-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span> Menü
        </button>

        <div className="d-lg-flex align-items-center d-none mr-3 meta-nav-wrapper">
          <ul className="nav lang-nav">
            <li>
              <a className="active" href="#">
                DE
              </a>
            </li>
            <li>
              <a href="#">EN</a>
            </li>
          </ul>
          <button
            className="btn btn-secondary d-none d-lg-block search-button"
            data-search-icon=""
            type="button"
          >
            <svg height="20" viewBox="0 0 19 20" width="19">
              <g
                fill="none"
                fillRule="evenodd"
                stroke="currentColor"
                transform="translate(1 1)"
              >
                <path
                  d="M16.5 17.5l-4-4"
                  strokeLinecap="round"
                  strokeWidth="3"
                ></path>
                <circle cx="7" cy="7" r="7" strokeWidth="2"></circle>
              </g>
            </svg>
            <span className="sr-only sr-only-focusable">Suchen</span>
          </button>
        </div>
      </div>

      {/* PAAS TITLE BAR */}
      <div className="navbar-banner bg-secondary py-1 w-100">
        <p className="container font-bigger leading-semi">
          FHNW Bootstrap Styleguide V5
        </p>
      </div>
    </>
  );
};

export default PaasHeader;
